import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

import ApraInfo from "../ApraInfo";
import Copyright from "../Copyright";
import SocialIcons from "../SocialIcons";
import CustomGrid from "./CustomGrid";
import Menu from "../Menu";

const { Box } = Chakra;

const FooterDesktop = ({ menus }) => (
  <CustomGrid pt={16} data-testid="footer-section">
    <Box>
      <ApraInfo />
      <Menu menu={menus.imprint} />
      <SocialIcons />
    </Box>
    <Menu label="menu_know_your_rights" menu={menus.knowYourRights} />
    <Box>
      <Menu label="menu_our_products" menu={menus.products} />
      <Box mt={5}>
        <Menu label="menu_support" menu={menus.support} />
      </Box>
    </Box>
    <Menu label="menu_our_company" menu={menus.company} />
    <Menu label="menu_other" menu={menus.legal} />
    <Box gridColumn="span 5" mt={-12} pt={10} pb={8} borderTop="1px" borderColor="#e3e8f0">
      <Copyright />
    </Box>
  </CustomGrid>
);

export default FooterDesktop;

FooterDesktop.propTypes = {
  menus: PropTypes.shape({
    knowYourRights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    support: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    company: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    legal: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    imprint: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};
